module.exports = __webpack_public_path__ + "__static/site-1751986109719/img/send-icon.dd51d806.svg";